export const furnitureLevelTwo = [
    {
      name: "Living Room",
      categoryId: "furniture_living_room",
      parentCategoryId: "home_furniture",
      level: 2,
    },
    {
      name: "Bedroom",
      categoryId: "furniture_bedroom",
      parentCategoryId: "home_furniture",
      level: 2,
    },
    {
      name: "Dining Room",
      categoryId: "furniture_dining_room",
      parentCategoryId: "home_furniture",
      level: 2,
    },
    {
      name: "Office",
      categoryId: "furniture_office",
      parentCategoryId: "home_furniture",
      level: 2,
    },
    {
      name: "Outdoor",
      categoryId: "furniture_outdoor",
      parentCategoryId: "home_furniture",
      level: 2,
    }
  ];
  